import DragConfig from "./dragConfig";

export default class DragState {
  constructor(public config: DragConfig) {
  }

  hoverOver($element: JQuery<HTMLElement>, event: MouseEvent): void {
    this.config.hoverOver($element, event);
  }

  hoverOverGridCell($element: JQuery<HTMLElement>, event: MouseEvent): void {
    // implemented in sub-classes where needed
    throw new Error('Method not implemented in DragState subclass.');
  }
  hoverOverGridElement($element: JQuery<HTMLElement>, event: MouseEvent): void {
    // implemented in sub-classes where needed
    throw new Error('Method not implemented in DragState subclass.');
  }
  leaveGrid($element: JQuery<HTMLElement>, event: MouseEvent): void {
    // implemented in sub-classes where needed
  }

  drag(event: MouseEvent): void {
    this.config.drag(event);
  }

  stopDrag(): void {
    this.config.stopDrag();
  }

  stopDragOnEmptyDropZone($emptyDragZone: JQuery<HTMLElement>, event: MouseEvent): void {
    this.config.stopDragOnEmptyDropZone($emptyDragZone, event);
  }

  get draggableSelector(): string {
    return this.config.draggableSelector;
  }

  get droppableSelector(): string {
    return this.config.droppableSelector;
  }

  mouseOut($element: JQuery<HTMLElement>, event: MouseEvent): void {
    this.config.mouseOut($element, event);
  }
}